import { render, staticRenderFns } from "./ByCategoryLists.vue?vue&type=template&id=cd1960fc"
import script from "./ByCategoryLists.vue?vue&type=script&lang=js"
export * from "./ByCategoryLists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports